// extracted by mini-css-extract-plugin
export default {"loader":"index_loader__MbS-D","dot":"index_dot__q-Lik","dotter":"index_dotter__uNXEz","glow":"index_glow__IxRAu"};